import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/graphtactics.png'
import _imports_1 from '@/assets/help.svg'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { id: "controls" }
const _hoisted_3 = { id: "logoname" }
const _hoisted_4 = { id: "logo" }
const _hoisted_5 = {
  alt: "GraphTactics logo",
  src: _imports_0
}
const _hoisted_6 = {
  key: 0,
  class: "spinner"
}
const _hoisted_7 = { id: "help" }
const _hoisted_8 = { id: "descriptif" }
const _hoisted_9 = {
  id: "inputs",
  class: "grid-container"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "t-ecoule" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "b-veh" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "b-veh" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { id: "clear" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help_modal = _resolveComponent("help-modal")!
  const _component_stats = _resolveComponent("stats")!
  const _component_l_control_layers = _resolveComponent("l-control-layers")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_geo_json = _resolveComponent("l-geo-json")!
  const _component_l_layer_group = _resolveComponent("l-layer-group")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showHelp)
      ? (_openBlock(), _createBlock(_component_help_modal, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHelp = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_vShow, !_ctx.loading]
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { id: "title" }, "GraphTactics", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _imports_1,
            width: "30px",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showHelp = true))
          })
        ]),
        _createElementVNode("div", {
          id: "lang-switch",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchLanguage && _ctx.switchLanguage(...args)))
        }, _toDisplayString(_ctx.currentLocale), 1)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('app.title')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('app.department')), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.zone) = $event)),
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onZoneChange())),
            class: "input-select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableNetworks, (network) => {
              return (_openBlock(), _createElementBlock("option", {
                key: network,
                value: network
              }, _toDisplayString(network), 9, _hoisted_10))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.zone]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('app.elapsedTime')), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            disabled: _ctx.loading || _ctx.results,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mins) = $event)),
            class: "input-number"
          }, null, 8, _hoisted_12), [
            [
              _vModelText,
              _ctx.mins,
              void 0,
              { number: true }
            ]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('app.mins')), 1)
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            disabled: _ctx.loading || _ctx.results,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.secs) = $event)),
            class: "input-number"
          }, null, 8, _hoisted_13), [
            [
              _vModelText,
              _ctx.secs,
              void 0,
              { number: true }
            ]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('app.secs')), 1)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('app.nbVehicles')), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            disabled: _ctx.loading || _ctx.results,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nb_random_vehicles) = $event)),
            class: "input-number"
          }, null, 8, _hoisted_14), [
            [
              _vModelText,
              _ctx.nb_random_vehicles,
              void 0,
              { number: true }
            ]
          ]),
          _cache[16] || (_cache[16] = _createTextVNode(" = x ", -1))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "button",
            disabled: _ctx.loading || _ctx.results,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getRandomVehicles && _ctx.getRandomVehicles(...args)))
          }, _toDisplayString(_ctx.$t('app.getVehicles')), 9, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "button",
            disabled: _ctx.loading || _ctx.results,
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.generatePlan && _ctx.generatePlan(...args)))
          }, _toDisplayString(_ctx.$t('app.generate')), 9, _hoisted_18)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "button-clear-dispo",
          disabled: _ctx.loading,
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearOutput && _ctx.clearOutput(...args)))
        }, _toDisplayString(_ctx.$t('app.clearOutput')), 9, _hoisted_20),
        _createElementVNode("button", {
          class: "button-clear-all",
          disabled: _ctx.loading,
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
        }, _toDisplayString(_ctx.$t('app.clearAll')), 9, _hoisted_21)
      ]),
      (_ctx.stats_model)
        ? (_openBlock(), _createBlock(_component_stats, {
            key: 0,
            stats: _ctx.stats_model
          }, null, 8, ["stats"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "outputs",
        innerHTML: _ctx.outputsContent
      }, null, 8, _hoisted_22)
    ]),
    _createVNode(_component_l_map, {
      ref: "map",
      zoom: _ctx.zoom,
      "onUpdate:zoom": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.zoom) = $event)),
      center: _ctx.center,
      "onUpdate:center": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.center) = $event)),
      bounds: _ctx.bounds,
      onClick: _ctx.addVehicle,
      id: "map"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_l_control_layers, {
          ref: "layerControl",
          position: "bottomleft"
        }, null, 512),
        _createVNode(_component_l_tile_layer, {
          disabled: true,
          url: _ctx.osmUrl
        }, null, 8, ["url"]),
        _createVNode(_component_l_layer_group, {
          name: _ctx.$t('app.layers.boundaries'),
          "layer-type": "overlay",
          ref: "boundaries_lg"
        }, {
          default: _withCtx(() => [
            (_ctx.boundariesGJ)
              ? (_openBlock(), _createBlock(_component_l_geo_json, {
                  key: 0,
                  geojson: _ctx.boundariesGJ,
                  "options-style": () => _ctx.boundaryStyle
                }, null, 8, ["geojson", "options-style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"]),
        (_ctx.originCoords)
          ? (_openBlock(), _createBlock(_component_l_marker, {
              key: 0,
              "lat-lng": _ctx.originCoords,
              "onUpdate:latLng": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.originCoords) = $event)),
              draggable: !_ctx.results && !_ctx.loading,
              clickable: true,
              icon: _ctx.originIcon,
              ref: "orig_marker"
            }, null, 8, ["lat-lng", "draggable", "icon"]))
          : _createCommentVNode("", true),
        _createVNode(_component_l_layer_group, {
          name: _ctx.$t('app.layers.escapeNodes'),
          "layer-type": "overlay",
          ref: "escape_points_lg"
        }, {
          default: _withCtx(() => [
            (_ctx.escapePointsGJ)
              ? (_openBlock(), _createBlock(_component_l_geo_json, {
                  geojson: _ctx.escapePointsGJ,
                  options: _ctx.escapePointsOptions,
                  key: _ctx.escapeNodesKey
                }, null, 8, ["geojson", "options"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_l_layer_group, {
          name: _ctx.$t('app.layers.vehicles'),
          "layer-type": "overlay"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicles, (v) => {
              return (_openBlock(), _createBlock(_component_l_marker, {
                key: v.id,
                visible: v.visible,
                draggable: !_ctx.results && !_ctx.loading,
                "lat-lng": v.position,
                "onUpdate:latLng": ($event: any) => ((v.position) = $event),
                icon: v.status == 0?_ctx.carAssignableIcon:v.status==3?_ctx.carAssignedIcon:_ctx.carUnassignedIcon,
                onClick: ($event: any) => (_ctx.removeVehicle(v))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_l_tooltip, {
                    content: v.tooltip,
                    options: { className: 'multiline-tooltip' }
                  }, null, 8, ["content"])
                ]),
                _: 2
              }, 1032, ["visible", "draggable", "lat-lng", "onUpdate:latLng", "icon", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["name"]),
        (_ctx.results)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.pastPaths'),
                "layer-type": "overlay",
                ref: "past_paths_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.pastPathsGJ)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.pastPathsGJ,
                        "options-style": () => _ctx.pastPathsStyle
                      }, null, 8, ["geojson", "options-style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.isochrones'),
                "layer-type": "overlay",
                ref: "isochrone_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.isochroneGJ)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.isochroneGJ,
                        "options-style": () => _ctx.isochroneStyle
                      }, null, 8, ["geojson", "options-style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.uncontrolledPaths'),
                "layer-type": "overlay",
                ref: "uncontrolled_paths_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.futurePathsUncontrolled)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.futurePathsUncontrolled,
                        "options-style": () => _ctx.uncontrolledPathsStyle
                      }, null, 8, ["geojson", "options-style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.toControlPaths'),
                "layer-type": "overlay",
                ref: "to_control_paths_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.futurePathsToControl)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.futurePathsToControl,
                        "options-style": () => _ctx.toControlPathsStyle
                      }, null, 8, ["geojson", "options-style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.fromControlPaths'),
                "layer-type": "overlay",
                ref: "from_control_paths_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.futurePathsFromControl)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.futurePathsFromControl,
                        "options-style": () => _ctx.fromControlPathsStyle
                      }, null, 8, ["geojson", "options-style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.assignments'),
                "layer-type": "overlay",
                ref: "assignments_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.assignmentsGJ)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.assignmentsGJ,
                        options: _ctx.assignmentsOptions
                      }, null, 8, ["geojson", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"]),
              _createVNode(_component_l_layer_group, {
                name: _ctx.$t('app.layers.controls'),
                "layer-type": "overlay",
                ref: "destinations_lg"
              }, {
                default: _withCtx(() => [
                  (_ctx.destinationsGJ)
                    ? (_openBlock(), _createBlock(_component_l_geo_json, {
                        key: 0,
                        geojson: _ctx.destinationsGJ,
                        options: _ctx.destinationsOptions
                      }, null, 8, ["geojson", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["zoom", "center", "bounds", "onClick"])
  ]))
}